import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Layout, Menu, Tooltip } from 'antd'
import Sider from 'antd/es/layout/Sider'
import { adminMenu } from '../../lists/adminMenu'
import { Content } from 'antd/es/layout/layout'
import { WrapperData } from '../../style/style'
import { useLocation, useNavigate } from 'react-router-dom'
import MyTable from '../../modules/MyTable/MyTable'
import { ColumnsType } from 'antd/es/table'
import { ContextType } from '../../type/type'
import { getRequestAuth } from '../../request/request'
import { errors } from '../../function/errors'
import UserManagementModal from './modal/UserManagementModal'
import moment from 'moment'
import { parseUrl } from '../../function/parseUrl'
import Search from 'antd/lib/input/Search'
import { AppContext } from '../../App'
import { useTranslation } from 'react-i18next'
import validatorServerErrors from '../../modules/ValidatorServerErrors/ValidatorServerErrors'
import BottomMenuInfo from '../../modules/BottomMenuInfo/BottomMenuInfo'
import { JWT } from '../../reduser/Reduser'
import { ReactComponent as PersonDeactivateIcon } from '../../static/icon/person_deactivate.svg'
import { ReactComponent as EditIcon } from '../../static/icon/edit.svg'
import Icon from '@ant-design/icons'


const UserManagement = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [data, setData] = useState<any>([])
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [clearForm, setClearForm] = useState<boolean>(false)
  const [reload, setReload] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [typeModal, setTypeModal] = useState<string | null>(null)
  const [editData, setEditData] = useState(null)
  const [reloadPagination, setReloadPagination] = useState<boolean>(false)
  const [dataSearch, setDataSearch] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = useLocation()
  const [sortOrder, setSortOrder] = useState<any | null>(null)
  const [pagination, setPagination] = useState(() => {
    const urlParams = new URLSearchParams(location.search)
    return {
      current: parseInt(urlParams.get('page') || '1', 10),
      pageSize: 50,
      total: 50,
    }
  })
  const type = pathname.split('/cabinet/')[1]
  const dateFormat = 'YYYY-MM-DD'
  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  useEffect(() => {

    setLoading(true)
    let meId: number | string

    const query = location.search.split('?')[1]
    const search = parseUrl('?', 'search')
    const ordering = parseUrl('?', 'ordering')

    if (search) setDataSearch(search)
    if (ordering) defaultOrdering(ordering)

    if (state?.me?.id) {
      meId = state.me.id
    } else {
      getRequestAuth('/profile/about_me/')
        .then((res: any) => {
          const { id } = res.data
          meId = id
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          dispatch({
            type: JWT,
            payload: null,
          })
        })
    }

    setLoading(true)
    getRequestAuth(`/auth/get_all_user/?is_active=true&${query || ''}`)
      .then((res: any) => {
        const data = prepareDataForTable(res?.data?.results)
        setData(data)
        setPagination({
          ...pagination,
          total: res?.data?.count,
        })
      })
      .catch((err) => {
        errors(err)
        validatorServerErrors(err.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [reload, reloadPagination, state.reload])

  const defaultOrdering = (ordering: string) => {
    const parts = ordering.split('-')

    if (parts.length > 1) {
      setSortOrder({ field: parts[1], order: 'descend' })
    } else {
      setSortOrder({ field: parts[0], order: 'ascend' })
    }
  }

  const columns: ColumnsType = [
    {
      title: t('h178'),
      dataIndex: 'name',
      key: 'name',
      width: 220,
      sorter: true,
      sortOrder: sortOrder?.field === 'name' ? sortOrder.order : undefined,
      render: (value) => (
       <div style={{maxWidth: 200}}>
        <span>{value}</span>
       </div>
      ),
    },
    {
      title: t('h65'),
      dataIndex: 'date_birthday',
      key: 'date_birthday',
      width: 70,
      render: (_, { date_birthday }: any) =>  {
        if (!date_birthday) {
          return '- -';
        }
        return moment(date_birthday, dateFormat).format(dateFormat)
      }
    },
    {
      title: t('h64'),
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
      render: (_, { phone }: any) => phone?.replace(/(\+\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/, '$1($2)$3-$4-$5')
    },
    {
      title: t('h49'),
      dataIndex: 'email',
      key: 'email',
      width: 70,
    },
    {
      title: '',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 70,
      render: (value) => (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5
        }}>
          <Tooltip title="Edit user">
            <Button onClick={() => editUser(value)} style={{padding: 0, lineHeight: 0, width: 36, height: 36, borderRadius: 18}}>
              <Icon component={EditIcon} style={{fontSize: 22}}></Icon>
            </Button>
          </Tooltip>
          <Button onClick={() => deleteUser(value)} style={{padding: 0, lineHeight: 0, width: 36, height: 36, borderRadius: 18}}>
            <Icon component={PersonDeactivateIcon} style={{fontSize: 22}}></Icon>
          </Button>
        </div>
      ),
    }
  ]

  const editUser = (id: number) => {
    const resultItem = data.find((item: any) => id === item.id)
    setEditData(resultItem)
    setTypeModal('edit')
    setIsModalOpen(true)
  }

  const deleteUser = (id: number) => {
     const resultItem = data.find((item: any) => id === item.id)
    setEditData(resultItem)
    setTypeModal('delete')
    setIsModalOpen(true)
  }

  const prepareDataForTable = (data: any) => {
    return data?.map(({ user, last_name, first_name, middle_name, date_birthday }: any) => {
      return {
        id: user?.id,
        name: `${last_name ?? ''} ${first_name ?? ''} ${middle_name ?? ''}`,
        date_birthday: date_birthday,
        phone: user?.phone,
        email: user?.email,
        last_name: last_name,
        first_name: first_name,
        middle_name: middle_name,
      }
    })
  }

  const onSearch = (value: string) => {
    setLoading(true)
    setDataSearch(value)
    setSortOrder(null)

    if (!value) {
      getRequestAuth('/auth/get_all_user/?is_active=true')
      .then((res: any) => {
        const data = prepareDataForTable(res?.data?.results)
        setData(data)
        navigate(``)
        setPagination({
          ...pagination,
          current: 1,
          total: res?.data?.count,
        })
      })
      .catch((err) => {
        errors(err)
        validatorServerErrors(err.data)
      })
      .finally(() => {
        setLoading(false)
      })
    } else {
      getRequestAuth(`/auth/get_all_user/?is_active=true&search=${encodeURIComponent(value)}`)
      .then((res: any) => {
        const data = prepareDataForTable(res?.data?.results)
        setData(data)
        navigate(`?search=${value}`)
        setPagination({
          ...pagination,
          current: 1,
          total: res?.data?.count,
        })
      })
      .catch((err) => {
        errors(err)
        validatorServerErrors(err.data)
      })
      .finally(() => {
        setLoading(false)
      })
    }
  }



  const userAdd = () => {
    setTypeModal('add')
    setIsModalOpen(true)
    setClearForm((prev) => !prev)
  }

  const handleCallbackModal = (e: boolean) => {
    setIsModalOpen(e)
    setEditData(null)
  }

  return (
    <Layout className="br-12">
      <Content>
        <WrapperData>
          <UserManagementModal
            isModalOpen={isModalOpen}
            setIsModalOpen={handleCallbackModal}
            setReload={setReload}
            typeModal={typeModal}
            editData={editData}
            clearForm={clearForm}
          />

          <Search
            placeholder={t('h194')}
            allowClear
            enterButton={t('h45')}
            size="large"
            value={dataSearch}
            onChange={({ target }) => {
              setDataSearch(target.value)
            }}
            onSearch={onSearch}
            className="search-trophies"
          />
          <br />
          <br />
         
            <Button
              onClick={userAdd}
              style={{
                marginBottom: 20,
                backgroundColor: '#4A552E',
                color: '#fff',
                borderColor: '#4A552E',
                boxShadow: '0 1px 4px 1px #E8EDE9',
              }}
            >
              {t('profile.p8')}
            </Button>
       
          <MyTable
            columns={columns}
            data={data}
            loading={loading}
            height={900}
            pagination={pagination}
            setPagination={setPagination}
            setReloadPagination={setReloadPagination}
            setSortOrder={setSortOrder}
            sortOrder={sortOrder}
            scroll={{ x: '100%' }}
          />
        </WrapperData>
      </Content>
    </Layout>
  )
}

export default UserManagement
